import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Submenu {
  name: string;
  link: string;
}

interface RoleMenu {
  menu: string;
  submenus: Submenu[];
}

interface UserData {
  id?: string | number;
  email?: string;
  name?: string;
  token?: string;
  role?: string;
  consignees?: any[];
  roleMenuList?: RoleMenu[];
  showHome?: boolean;
  showTracking?: boolean;
  // Header company logo filename; set at login from the user's single Dropdown 1
  // (Customer Group Name) customer, else absent.
  companyLogo?: string | null;
  // Header company name, from the same single Dropdown 1 customer.
  companyName?: string | null;
}

interface AuthState {
  isAuthenticated: boolean;
  user: UserData | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  loading: false,
  error: null
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<UserData>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    updateUserMenu: (state, action: PayloadAction<{ roleMenuList: any[]; showHome?: boolean; showTracking?: boolean }>) => {
      if (state.user) {
        state.user.roleMenuList = action.payload.roleMenuList;
        if (action.payload.showHome !== undefined) {
          state.user.showHome = action.payload.showHome;
        }
        if (action.payload.showTracking !== undefined) {
          state.user.showTracking = action.payload.showTracking;
        }
      }
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      // Clear the token from localStorage
      localStorage.removeItem('authToken');

      // Reset the auth state
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const { loginRequest, loginSuccess, updateUserMenu, loginFailure, logout, clearError } = AuthSlice.actions;

export const AuthReducer = AuthSlice.reducer; 